import type { CSSProperties } from 'react';
import type { BallColorGroup } from '@platform/contracts/x';
import { useUi } from './config';
export function useBallStyle(number: number | null, groups: BallColorGroup[]) {
  const ui = useUi();
  const group = groups.find(g => number !== null && g.numbers.includes(number));
  const palette = group ? (ui.ballPalette as Record<string, typeof ui.ballPalette.yellow>)[group.id] : undefined;
  const style = palette ? { '--ball-base': palette.base, '--ball-soft': palette.soft, '--ball-ink': palette.ink, '--ball-on': palette.on } as CSSProperties : undefined;
  return { group, style };
}
export function Ball({ number, groups, className = '', dim = false }: { number: number; groups: BallColorGroup[]; className?: string; dim?: boolean }) {
  const { group, style } = useBallStyle(number, groups);
  return <span data-ui="ball" data-color={group?.id} className={'number-ball ' + className + (dim ? ' dim' : '')} style={style} title={number + (group ? ' · ' + group.label : '')}><span>{number}</span></span>;
}
export function ColorLegend({ groups }: { groups: BallColorGroup[] }) {
  return <div className="color-legend" data-ui="color-legend">{groups.map(group => <LegendItem key={group.id} group={group}/>)}</div>;
}
function LegendItem({ group }: { group: BallColorGroup }) {
  const { style } = useBallStyle(group.numbers[0], [group]);
  return <span style={style}><i/><b>{group.label}</b><small>{Math.min(...group.numbers)}–{Math.max(...group.numbers)}</small></span>;
}
